import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';
import { NotesSection } from '../../../components/Notes';
import { useDispatch, useSelector } from 'react-redux';
import { BID_INCREMENT, VEHICLE_STATUSES } from 'constants';
import moment from 'moment';
import { getMinBitAmount, getUserHighestBid, getVehicleTimer } from 'utils/vehicle';
import InfoElement from '../InfoElement';
import { IncreaseHighBid } from 'pages/Buyer/BidsList/containers';
import { BuyNowButton } from '../BuyNowButton';
import api from 'services/api/my-bids';

const BidInfoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const HoverWrapper = styled.div<{ isExpanded: boolean }>`
  display: ${({ isExpanded }) => (isExpanded ? 'flex' : 'none')};
  margin-top: 30px;
  padding-top: 8px;
  border-top: 1px solid #e5e5e5;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

type Props = {
  vehicle: Vehicle;
  isExpanded: boolean;
};

export const HoverView = ({ vehicle, isExpanded }: Props) => {
  const user = useSelector((state: any) => state.user.user);
  const dispatch = useDispatch();

  const vehicleTimer = getVehicleTimer(vehicle);
  const canPlaceBid =
    user?.role === 'buyer' && vehicle.status === VEHICLE_STATUSES.ACTIVE && moment(vehicleTimer).isAfter(moment());

  const minBidAmount = getMinBitAmount(vehicle, user);

  const isAlternativeAuction = vehicle.auction.type !== 'autoaxess';

  // const invalidateSidePanel = () => {
  //   if (isAlternativeAuction) {
  //     dispatch(api.util.invalidateTags(['SidePanelBids']));
  //   }
  // };

  return (
    <HoverWrapper isExpanded={isExpanded}>
      <BidInfoContentWrapper>
        {isAlternativeAuction ? <AlternativeInfo vehicle={vehicle} /> : <AAInfo vehicle={vehicle} />}
        <NotesSection vehicle={vehicle} />
      </BidInfoContentWrapper>
      {canPlaceBid && (
        <IncreaseHighBid
          isSidePanelBid
          variant={isAlternativeAuction ? 'alternative_offer' : 'default'}
          form={`biddingForm_${vehicle.id}`}
          vehicleId={vehicle.id}
          minAmount={minBidAmount}
          // additionalAction={invalidateSidePanel}
          bidIncrement={BID_INCREMENT}
          type={isAlternativeAuction ? 'alternative_offer' : 'bid'}
        />
      )}
      {isAlternativeAuction && vehicle.status === 'active' && !vehicle.in_battle && <BuyNowButton vehicle={vehicle} />}
    </HoverWrapper>
  );
};

const AAInfo = ({ vehicle }: { vehicle: Vehicle }) => {
  const user = useSelector((state: any) => state.user.user);
  const myBid = vehicle.my_bid;

  const userHighestBid = getUserHighestBid(vehicle, user?.id);
  const highBidTitle = userHighestBid.isProxy ? 'High Bid (proxy)' : 'High Bid';

  return (
    <>
      <InfoElement type="currency" item="Your Bid" value={myBid?.amount ?? '-'} highlighted />
      <InfoElement type="currency" item={highBidTitle} value={userHighestBid?.amount ?? '-'} highlighted />
    </>
  );
};

const AlternativeInfo = ({ vehicle }: { vehicle: Vehicle }) => {
  return (
    <>
      <InfoElement
        type="currency"
        item="Your Offer"
        value={vehicle.my_alternative_bid_offer?.amount ?? '-'}
        highlighted
      />
    </>
  );
};
